export default import.meta.ROLLUP_FILE_URL_aFi9nQAq3C1Ou0q5i7Rh6w